import { isAfter, isBefore } from 'date-fns'
import type { DateRange } from 'react-day-picker'

export function getAlternatingRangeValue(
  currentValue: DateRange | null,
  clickedDate: Date,
  boundary: 'from' | 'to'
): { range: DateRange; nextBoundary: 'from' | 'to' } {
  if (boundary === 'from') {
    const currentTo = currentValue?.to
    if (!currentTo) {
      return {
        range: { from: clickedDate, to: undefined },
        nextBoundary: 'to',
      }
    }

    return {
      range: isAfter(clickedDate, currentTo)
        ? { from: clickedDate, to: clickedDate }
        : { from: clickedDate, to: currentTo },
      nextBoundary: 'to',
    }
  }

  const currentFrom = currentValue?.from
  if (!currentFrom) {
    return {
      range: { from: clickedDate, to: clickedDate },
      nextBoundary: 'to',
    }
  }

  if (isBefore(clickedDate, currentFrom)) {
    return {
      range: { from: clickedDate, to: clickedDate },
      // Keep editing end after collapsing, so next click can expand to a range.
      nextBoundary: 'to',
    }
  }

  return {
    range: { from: currentFrom, to: clickedDate },
    nextBoundary: 'from',
  }
}
